import React from 'react';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import BugReportOutlinedIcon from '@mui/icons-material/BugReportOutlined';
import IssueReportDialog from './IssueReportDialog';

export default function IssueReporter({ isAuthenticated, reporter, compact = false }) {
    const [open, setOpen] = React.useState(false);

    if (!isAuthenticated) {
        return null;
    }

    const trigger = compact ? (
        <Tooltip title="Fehler melden">
            <IconButton color="inherit" onClick={() => setOpen(true)}>
                <BugReportOutlinedIcon />
            </IconButton>
        </Tooltip>
    ) : (
        <Button
            color="inherit"
            startIcon={<BugReportOutlinedIcon />}
            onClick={() => setOpen(true)}
        >
            Fehler melden
        </Button>
    );

    return (
        <>
            {trigger}
            <IssueReportDialog open={open} onClose={() => setOpen(false)} reporter={reporter} />
        </>
    );
}
